import React, { useEffect, useState } from 'react'

import { useAxios } from '../../utilities/Requests/useAxios'

export interface PassportResponseObj {
  providerHourRequirement: number
  groupHourRequirement: number
  totalHourRequirement: number
  weeks: WeeklyPassportResponseObj[]
}

export interface WeeklyPassportResponseObj {
  weekNumber: number
  startOfWeek: string
  isCurrentWeek: boolean
  peerGroupsHours: number
  providerAppointmentHours: number
  totalHours: number
}

export interface PassportEncouragementTextObj {
  text: string
  isDoingWell: boolean
}

export interface PassportContextInterface {
  getPatientPassportData: (patientId: number) => Promise<PassportResponseObj>
  passportResponse: PassportResponseObj
}

export const PassportContext =
  React.createContext<PassportContextInterface | null>(null)

export const PassportProvider = ({ children }: any) => {
  const { fetch } = useAxios()

  const [timezoneStr, setTimezoneStr] = useState<string | null>('')

  const getTimezoneId = async () => {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      setTimezoneStr(timezone)
    } catch (error) {
      return 'error getting timezone' // Fallback to UTC if there's an error
    }
  }

  useEffect(() => {
    getTimezoneId()
  }, [])

  const [passportResponse, setPassportResponse] = useState<PassportResponseObj>(
    {
      providerHourRequirement: 0,
      groupHourRequirement: 0,
      totalHourRequirement: 0,
      weeks: [],
    }
  )

  const getPatientPassportData = async (patientId: number) => {
    try {
      const { data } = await fetch({
        path: `MyPassport/GetPatientPassportData?timezone=${timezoneStr}&patientId=${patientId}`,
      })
      setPassportResponse(data)
      return data
    } catch (error) {
      console.log('Error Getting Passport Record: ', error)
    }
  }

  return (
    <PassportContext.Provider
      value={{
        getPatientPassportData,
        passportResponse,
      }}
    >
      {children}
    </PassportContext.Provider>
  )
}
